import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'psm-section',
    templateUrl: 'section.component.html',
    styleUrls: ['./layout.component.scss', './section.component.scss']
})

export class SectionComponent {
    @Input() public id: number;
    @Input() public isActive: boolean = false;
    @Input() public isValid: boolean = true;
    @Input() public type: string = '';

    @Output() public click: EventEmitter<void> = new EventEmitter();

    public onClick() {
        this.click.emit();
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/section.component.ts